import { Directive, Input, ViewContainerRef } from '@angular/core';
var NgTranscludeDirective = (function () {
    function NgTranscludeDirective(viewRef) {
        this.viewRef = viewRef;
    }
    Object.defineProperty(NgTranscludeDirective.prototype, "ngTransclude", {
        get: function () {
            return this._ngTransclude;
        },
        set: function (templateRef) {
            this._ngTransclude = templateRef;
            if (templateRef) {
                this.viewRef.createEmbeddedView(templateRef);
            }
        },
        enumerable: true,
        configurable: true
    });
    NgTranscludeDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[ngTransclude]'
                },] },
    ];
    /** @nocollapse */
    NgTranscludeDirective.ctorParameters = function () { return [
        { type: ViewContainerRef, },
    ]; };
    NgTranscludeDirective.propDecorators = {
        'ngTransclude': [{ type: Input },],
    };
    return NgTranscludeDirective;
}());
export { NgTranscludeDirective };
//# sourceMappingURL=ng-transclude.directive.js.map


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/ngx-bootstrap/tabs/ng-transclude.directive.js
// module id = ../../../../ngx-bootstrap/tabs/ng-transclude.directive.js
// module chunks = 4